import { createStyles, makeStyles } from '@material-ui/styles'
import colors from 'shared/style/colors'
import { Theme } from '@material-ui/core'

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    standFirst: {
      borderLeft: `3px solid ${colors.primary}`,
      margin: '1rem 0 2rem',
      paddingLeft: '1rem',
      fontWeight: 600
    }
  })
)
